import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { usePageData } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/PageDataContext.js";
import Header from "./Header.js";
const HeaderContainer = ({ hasNavigation, ...rest }) => {
  const { logo } = usePageData();
  const { getLabel } = useIntl();
  const currentBreakpoint = MediaQuery.useBreakpoint();
  const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
  return /* @__PURE__ */ React.createElement(
    Header,
    {
      ...rest,
      isMobile,
      logo,
      hasNavigation,
      title: getLabel("appointments.component.headerContainer.linkTitle")
    }
  );
};
export {
  HeaderContainer as default
};
//# sourceMappingURL=HeaderContainer.js.map
